import { Injectable } from '@angular/core';
import { WmHttpService } from "../http/wm-http.service";
import { EventManagerService } from "@wms/app";
import { PreferenceService } from '../preference/preference.service';
import { find } from 'lodash-es';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class StudioService {
  isSilo: boolean = false;
  organizationList: any;
  selectedOrganization:any;
  studioInfo:any;
  editInWM: boolean;
  constructor(private wmHttpService: WmHttpService, private eventManager: EventManagerService, private preferencesService: PreferenceService, private userService: UserService) { }

  getSelectedOrganization(): Promise<any> {
    let $promise: Promise<any>;
    if (this.organizationList) {
      $promise = Promise.resolve(this.organizationList);
    } else {
      $promise = this.getOrganizationsList();
    }
    return $promise.then((res: any) => {
      this.organizationList = res;
      const user = this.userService.get();
      this.selectedOrganization = find(res, (org: { entId: any; }) => org.entId === user.entId);
      this.isSilo = this.selectedOrganization.mode === 'OWN' && this.preferencesService.get('workspace.wmEnv') !== 'WME';
      return this.selectedOrganization;
    });

  }


  getOrganizationsList(): Promise<any> {
    return (this.wmHttpService.execute({ target: "Studio", action: "organizationsList" }) as Promise<any>);
  }

  getAboutInfo(): Promise<any> {
    return (this.wmHttpService.execute({ target: "Studio", action: "about" }) as Promise<any>);
  }

  getStudioInfo(): Promise<any>{
    if (this.studioInfo) {
    return Promise.resolve(this.studioInfo);
    } else {
      return this.getAboutInfo().then((res)=>{
        this.studioInfo=res
        return this.studioInfo
      })
    }

  }

  setEditInWM(value: any) {
    this.editInWM = value;
  }

  getEditInWM() {
    return this.editInWM;
  }
}
